import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { L10nLocale, L10N_LOCALE, L10nTranslatePipe } from 'angular-l10n';

export interface ErrorData {
  title: string,
  message?: string,
  error?: string,
  ok?: string,
}

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    L10nTranslatePipe,
  ],
})
export class ErrorComponent {
  readonly locale = inject<L10nLocale>(L10N_LOCALE);
  readonly dialogRef = inject<MatDialogRef<ErrorComponent>>(MatDialogRef);
  readonly data = inject<ErrorData>(MAT_DIALOG_DATA);
}
